import { AddOperation, DeltaUpdateOperation, SchemaObject, SignalOperation, UpdateOperation } from '@augloop/types-core';
import { Log, LogCategory, Operation as LogOperation } from '@augloop/logging';
import { isParentContextId } from './utils';
export const supportedOperationSet = new Set([
    AddOperation.getTypeName(),
    UpdateOperation.getTypeName(),
    SignalOperation.getTypeName(),
    DeltaUpdateOperation.getTypeName()
]);
export class ContextIdManager {
    constructor(runtimeKind, workflowGraph) {
        this.nextId = 1;
        this.runtimeKind = runtimeKind;
        this.workflowGraph = workflowGraph;
    }
    static isParentContextId(parentContextId, childContextId) {
        return isParentContextId(parentContextId, childContextId);
    }
    applyContextIdOnOperations(ops) {
        for (const op of ops) {
            const opType = SchemaObject.getTypeNameFor(op);
            if (!this.isSupportedOperation(opType)) {
                continue;
            }
            for (const item of op.items) {
                if (!item.contextId) {
                    item.contextId = this.addNewContextId();
                    continue;
                }
                if (item.source && this.workflowGraph.getWorkflow(item.source, false /** external */)) {
                    item.contextId = this.addNewContextId(item.contextId);
                    continue;
                }
                this.tryLogMessage(new LogOperation({ operationName: 'ApplyContextIdOnOperations', success: true }).start(), 'Item with a contextId but without a workflow source atribute');
            }
        }
    }
    addNewContextId(contextId) {
        const newKey = `${this.runtimeKind}${this.nextId++}`;
        return contextId ? `${contextId}.${newKey}` : newKey;
    }
    isSupportedOperation(operationType) {
        return supportedOperationSet.has(operationType);
    }
    tryLogMessage(logOp, message, success = true) {
        if (logOp) {
            logOp.success = success;
            logOp.resultDescription = message;
            Log.verbose(0x1f6e1759 /* tag_5173z */, LogCategory.CoreDefault, logOp.stop());
        }
    }
}
export var ExecutionState;
(function (ExecutionState) {
    ExecutionState[ExecutionState["Idle"] = 1] = "Idle";
    ExecutionState[ExecutionState["Pending"] = 2] = "Pending";
    ExecutionState[ExecutionState["Running"] = 3] = "Running";
    ExecutionState[ExecutionState["Executed"] = 4] = "Executed";
})(ExecutionState || (ExecutionState = {}));
//# sourceMappingURL=context-id-manager.js.map